module.exports = __webpack_public_path__ + "img/nsp.0960db73.png";